<div id="divMessages" class="player-profile-tab-content">
  @if (!reload) {
    <app-player-profile-messages-list filterFunctionCd="NOTIFICATION_NEARBY" [positionTop]="positionTop"/>
  }
</div>
